import * as React from 'react'
import './downarrow.css'

export const DownArrow = (props: any) =>
<svg id="back_1_" data-name="back (1)" xmlns="http://www.w3.org/2000/svg" width={props.svgwidth || 11.615} height={props.svgheight || 6.395} viewBox="0 0 11.615 6.395">
  <g id="back_1_2" data-name="back (1)" transform="translate(0 6.395) rotate(-90)">
    <path id="Chevron_Right" className="down-1" d="M.17,6.222l5.223,5.221a.586.586,0,1,0,.83-.829L1.414,5.808,6.223,1a.587.587,0,0,0-.83-.829L.169,5.393A.592.592,0,0,0,.17,6.222Z"/>
  </g>
</svg>
